import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import { WORK_SESSION_LOG_SCAN } from "graphql/mutation/attendance-gql";


const useAttendanceMutationScan = () => {
    const [ scan, { loading, error } ] = useMutation(WORK_SESSION_LOG_SCAN, {
        update: (cache, { data }) => {
            if (data?.workSessionLogScan?.workSessionLog?.status !== "success") {
                return;
            }

            cache.evict({
                id: "ROOT_QUERY",
                fieldName: "workSessionsCursor"
            });
            cache.gc();
        }
    });

    const attendanceScan = useCallback((input) => scan({
        variables: {
            input
        }
    }), [ scan ]);

    return {
        attendanceScan,
        loading,
        error
    };
};

export default useAttendanceMutationScan;
